import { __rest } from '../../_virtual/_tslib.js';
import React from 'react';
import { fComp } from '../../utils/React.js';
import { fragmentMap } from '../../utils/ReactUtils.js';

var defaultProps = {};
var TabsItemPresentation = fComp(function (_a) {
  var horizontalAlignment = _a.horizontalAlignment,
    props = __rest(_a, ["horizontalAlignment"]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, fragmentMap(props.children, function (child) {
    return /*#__PURE__*/React.cloneElement(child, {
      horizontalAlignment: horizontalAlignment
    });
  }));
}, defaultProps);
TabsItemPresentation.displayName = "TabsItemPresentation";

export { TabsItemPresentation, defaultProps };
